const APIS = {
  ORDER: `/order/`,
  STATUS: "/status/",
  STATUS_NEXT: "/status/next-status/",
  LOCATION: "/location/",
  MANIFEST: "/manifest/",
  MANIFEST_ITEMS: "/manifest-items/",
  PRODUCT_TYPE: "/product-type/",
  PAYMENT_METHOD_TYPE: "/payment-method/",
  REFERENCE_TYPE: "/reference-type/",
  SERVICE_TYPE: "/service-type/",
  WAREHOUSE: "/warehouse/",
  BRANCH: "/branch/",
  DEFAULT_BRANCH: "/branch/default-branch/",
  DELIVERY_CHARGE: "/delivery-charge/",
  DELIVERY_CHARGE_TEMPLATE: "/delivery-charge-template/",
  CUSTOMER: "/customer/",
  RIDER: "/rider/",
  STAFF: "/staff/",
  MERCHANT: "/merchant/",
  REMARK: "/remark/",
  USER: "/user/",
  PROFILE: "/profile/",
  GROUP: "/role/",
  PERMISSIONS: "/permissions/",
  USER_PROFILE: "/user-profile/",
  GRID_REPORT_DATA: "/grid-report-data/",
  CHANGE_PASSWORD:"/user/set-password/",
  BUSINESS_PROFILE: "/business-profile/",
  TIMEZONES: "/business-profile/timezones/",
  CURRENCY: "/business-profile/currencies/",
  ORDER_BY_ID: "/order/download-order-by-id/",
  ORDER_OVERVIEW_FILTER_BY: "/business-profile/order-overview-filter-by/",
  INVOICE: "/invoice/",
  BRANCH_WISE_ORDER_REPORT: "/report-data/branch-wise-delivery-graph/",
  EARNING_REPORT: "/report-data/earning-graph/",
  ORDER_REPORT: "/report-data/order-graph/",
  REPORT: "/report-data/",
  MERCHANT_ORDER_REPORT: "/report-data/merchant-graph/",
  API_KEY: "/v1/api-key/",
  GRID_REPORT: "/report-data/",
  PAYMENT_METHOD:"/invoice/payment-method/",
  MAKE_PAYMENT:"/invoice/make-payment/",
  CALCULATED_DELIVERY_CHARGE:"/delivery-charge/delivery-charge-cost/",
  TICKET:"/ticket/",
  TICKET_QUEUE:"/queue/",
  NOTIFICATION:"/notification/",
  KM_RECORD_SETTING:"/per-km-record/",
  KM_RECORD:"/km-record/",
  ORDER_HISTORY: "/order-history/",
  OVERVIEW_ORDER: "/overview-order/",
  WEBSITE_INFO:"/basic-website-info/",
  VEHILCE:"/vehicle/",
  VEHILCE_TYPE:"/vehicle-type/",
  VEHILCE_CATEGORY:"/vehicle-category/",
  DRIVER:"/driver/"
};

export default APIS;
